import {useMediaQuery} from "@mui/material";
import json2mq from "json2mq";

export type Orientation = "portrait" | "landscape";

export function useOrientation(): Orientation {
    const portrait = useMediaQuery(json2mq({orientation: "portrait"}));
    const landscape = useMediaQuery(json2mq({orientation: "landscape"}));
    return landscape ? "landscape" : portrait ? "portrait" : "DEADBEEF" as Orientation;
}

